import { h } from "preact";
import { Header, Image, Grid } from "semantic-ui-react";
import icons from "../../../assets/icons";
import styles from "./UserRow.scss";
import TimeAgo from "javascript-time-ago";
import en from "javascript-time-ago/locale/en";
import { route } from "preact-router";
import classNames from "classnames";

TimeAgo.addLocale(en);
const timeAgo = new TimeAgo("en-US");

const MIN_DAYS_RED = 7;
const MIN_DAYS_YELLOW = 2;

const colors = ["#FFCCCC", "#FFE6CC", "#FFFFCC", "#E6F3CC", "#CCE6CC"];

const UserRow = ({ user }) => {
  const userMoods = [];

  for (let index = 0; index < 5; index++) {
    if (user.entries[index]) {
      userMoods.push(
        <Grid.Column key={user.entries[index].id} className={styles.cell}>
          <div
            id="ratingColor"
            className={styles.progress}
            style={{
              height: `calc(20% * ${user.entries[index].rating}`,
              backgroundColor: colors[user.entries[index].rating - 1],
            }}
          />
          <Image
            className={styles.ratingImage}
            src={icons[user.entries[index].rating - 1]}
            size="mini"
          />
        </Grid.Column>
      );
    } else userMoods.push(<Grid.Column />);
  }

  let daysAgo = MIN_DAYS_RED;
  let lastEntryDate;

  if (user.entries.length > 0) {
    lastEntryDate = new Date(user.entries[0].date);
    daysAgo = Math.floor((new Date() - lastEntryDate) / (1000 * 60 * 60 * 24));
  }

  let color;
  switch (true) {
    case daysAgo >= MIN_DAYS_RED:
      color = "red";
      break;
    case daysAgo >= MIN_DAYS_YELLOW:
      color = "yellow";
      break;
    default:
      color = "green";
      break;
  }

  return (
    <Grid className={styles.rowContainer} celled columns="equal">
      <Grid.Row
        className={classNames(styles.userRow, styles[color])}
        onClick={() => {
          route(`/overview/${user.id}?transition=none`);
        }}
        title={`Detailed overview of ${user.first_name}`}
      >
        <Grid.Column className={styles.cell}>
          <Header image>
            <Image src={user.picture_url} rounded size="tiny" />
            <Header.Content>
              {user.first_name + " " + user.last_name}
            </Header.Content>
            <Header.Subheader>
              {lastEntryDate
                ? `Last entry made ${timeAgo.format(lastEntryDate)}`
                : "Never made an entry"}
            </Header.Subheader>
          </Header>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row className={styles.moodRow}>{userMoods}</Grid.Row>
    </Grid>
  );
};

export default UserRow;



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/UserRow.js